<script lang="ts">
  import type { Snippet } from 'svelte';

  type Props = {
    domRef?: HTMLDivElement;
    imgRef?: HTMLImageElement;
    children: Snippet;
  };
  let {
    imgRef = $bindable(),
    domRef = $bindable(),
    children,
  }: Props = $props();
</script>

<img class="rendered-img" bind:this={imgRef} alt="share thumbnail" />
<div class="container" bind:this={domRef}>
  {@render children()}
</div>

<style lang="scss">
  @use '~/theme/theme';
  @use '~/theme/themify' as *;

  .rendered-img {
    width: 100%;
  }
  .container {
    font-family: 'Poppins';
    display: none;
    position: relative;
    width: 1200px;
    height: 630px;
    padding: 108px 64px;
    @include themify {
      background-color: themed('background');
    }
  }
</style>
